import React, { useState } from 'react';
import { Typography, Box, styled, useMediaQuery } from '@mui/material';
import { Icon } from "@iconify/react";
import "react-responsive-carousel/lib/styles/carousel.min.css";
import AliceCarousel from 'react-alice-carousel';
import 'react-alice-carousel/lib/alice-carousel.css';

const Container = styled(Box)(({theme}) => ({
        marginLeft: '20%',
        marginRight: '20%',
        justifyContent: 'center',
    })
);

const MobileContainer = styled(Box)({
    padding: '0 20px',
    justifyContent: 'center',
});

const Certifications =[
    {
        id: 1,
        title: 'Product Strategy Micro-Certification (PSC)',
        link: 'https://drive.google.com/file/d/16w74JoZUZznEdNiA1_inPm5kmtSAiZn9/view',
        description: 'This certification from product school is higly relevant in my role as it equipped me with a broader understanding outlining strategic vision for a product offering by stating where the product is going, how it will get there, and why it will succeed.',
    },
    {
        id: 2,
        title: 'Product Analytics Micro-Certification (PAC)',
        link: 'https://drive.google.com/file/d/1LDAVkf3sw775dunGvBBQSUWdozQ4UQZb/view',
        description: 'The certification provided thorough expertise in utilizing advanced data analysis techniques and tools to extract actionable insights regarding user behavior, product performance, and market trends, enabling informed product decision-making.',
    },
    {
        id: 3,
        title: 'Software Product Management',
        link: 'https://www.coursera.org/account/accomplishments/certificate/7AN8XF9SL4WF',
        description: 'This earned certification encompasses the following key aspects: Relating software product management to better software products. Recognizing the vital role of a software product manager. Reflecting on how Agile principles enhance project outcomes.',
    },
    {
        id: 4,
        title: 'DevOps Practices',
        link: 'https://www.udemy.com/certificate/UC-5b0e741d-1a73-4637-9577-9d774b0dead4/',
        description: 'To enhance the dependable and scalable release of product offerings, this certification provided me with a comprehensive grasp of DevOps practices and their advantages in product iteration.',
    },
];

const Strengths =[
    {
        title: 'User-Focused',
        brief: 'My primary aim is to always grasp the needs and challenges of our customers and users, ensuring that our work delivers real value to them.',
    },
    {
        title: 'Data-Driven Research',
        brief: 'I understand the importance of using data and analytics to guide decision-making when it comes to improving our products.',
    },
    {
        title: 'Effective Communication and Collaboration',
        brief: 'I excel in communicating with both technical teams and non-technical stakeholders by simplifying complex technical concepts into easily understandable language.',
    },
    {
        title: 'Versatile Methodologies and Processes',
        brief: 'I am well-versed in various development methodologies and processes, such as Agile, Lean, and ExP, enabling me to select the best approach for a project and put it into practice effectively.',
    },
    {
        title: 'Strong Technical Proficiency',
        brief: 'With my technical background, I make valuable contributions to the product team during the delivery process, leading to quicker and more strategic feature releases.',
    },
    {
        title: 'Leadership',
        brief: 'I also recognize the vital importance of motivating and inspiring cross-functional teams to achieve our product goals. ',
    },
];

const Skills =[
    {
        type: 'Product Skills',
        list: 'Discovery & Delivery, Product Thinking, Design Thinking, Strategy, Analysis, Decision-making, Backlog Prioritization, Sprint Planning, Research, User Journey & Mapping, Wireframing, etc.',
    },
    {
        type: 'Technical Proficiency',
        list: 'Software Development, APIs and integrations, DevOps, Quality Assurance, RDBMS',
    },
    {
        type: 'Soft Skills',
        list: 'Cross-Functional Team Collaboration, Communication, Positive Attitude',
    },
];

const items = [
    <div data-value="1"><Icon icon='skill-icons:figma-light' style={{height:'25%', width:'25%',justifyContent:'center'}}/></div>,
    <div data-value="1"><Icon icon='devicon:google' style={{height:'25%', width:'25%', justifyContent:'center'}}/></div>,
    <div data-value="1"><Icon icon='devicon:github' style={{height:'25%', width:'25%', justifyContent:'center'}}/></div>,
    <div data-value="1"><Icon icon='devicon:jira-wordmark' style={{height:'25%', width:'25%', justifyContent:'center'}}/></div>,
    <div data-value="1"><Icon icon='simple-icons:miro' style={{height:'25%', width:'25%', justifyContent:'center'}}/></div>,
    <div data-value="1"><Icon icon='logos:slack-icon'style={{height:'25%', width:'25%', justifyContent:'center'}}/></div>,
    <div data-value="1"><Icon icon='logos:asana-icon'style={{height:'25%', width:'25%', justifyContent:'center'}}/></div>,
    <div data-value="1"><Icon icon='logos:trello'style={{height:'25%', width:'25%', justifyContent:'center'}}/></div>,
    <div data-value="1"><Icon icon='logos:optimizely-icon' style={{height:'25%', width:'25%', justifyContent:'center'}}/></div>,
    <div data-value="1"><Icon icon='logos:notion-icon' style={{height:'25%', width:'25%', justifyContent:'center'}}/></div>,
    <div data-value="1"><Icon icon='logos:postman-icon' style={{height:'25%', width:'25%', justifyContent:'center'}}/></div>,
    <div data-value="1"><Icon icon='logos:swagger' style={{height:'25%', width:'25%', justifyContent:'center'}}/></div>,
    <div data-value="1"><Icon icon='devicon:gitbook' style={{height:'25%', width:'25%', justifyContent:'center'}}/></div>,
    <div data-value="1"><Icon icon='logos:sentry-icon' style={{height:'25%', width:'25%', justifyContent:'center'}}/></div>,
    <div data-value="1"><Icon icon='devicon:sketch' style={{height:'25%', width:'25%', justifyContent:'center'}}/></div>,
    <div data-value="1"><Icon icon='logos:aha' style={{height:'25%', width:'25%', justifyContent:'center'}}/></div>,
];

const responsive = {
    0: { items: 1 },
    568: { items: 2 },
    1024: { items: 3 },
};

const Intrests =[
    {
        name: 'Innovations or products that solve real-world problems. '
    },
    {
        name: 'Human-Computer Interaction(HCI).'
    },
    {
        name: 'Outside tech, i am a lover of fashion and music.'
    },
    {
        name: 'I am a huge fan of Beyonce!'
    },
];

const AboutMe =()=>{
    const [openedDescription, setOpenedDescription] = useState(-1)
    const mediaQuery = useMediaQuery('(min-width:1024px)');

    return(
        <>
        <div>
        {/* <MiniAbout/> */}

        <br/><br/><br/>
        { mediaQuery ?
            <Container>
                <Typography
                    style={{fontFamily:'Oswald', textAlign:'center', lineHeight:'3', fontSize:'25px', letterSpacing:'3px'}}
                >
                    TECHNICAL PRODUCT MANAGER | (TECH ENTHUSIAST & ADVOCATE)
                </Typography>
                <Typography
                    style={{letterSpacing:'1px', lineHeight:'2'}}
                >
                  <b>
  <p>
    I’m a <strong>Technical Product Manager</strong> passionate about making people’s lives easier through digital technology. What drives me is seeing how innovation can simplify complex processes and create real impact. I care about building things that last and truly matter.
  </p>

  <p>
    In my role, I bridge the gap between technical teams and stakeholders, ensuring that the products we build deliver real, tangible value.
  </p>

  <p>
    With over four years of experience in the geospatial and GovTech sector, I have worked on and launched products that have supported institutional change and driven social and economic impact.
  </p>

  <p>
    The advancement of AI has sparked my fascination with computer vision. I am exploring its applications because I believe true intelligence involves systems that can see and act on what they observe in real time.
  </p>

<p>
    Beyond my product work, I am diving into scientific AI research, focusing on understanding the mechanics behind technology and experimenting with efficiently training AI models.
</p>
  <p>
    My early experience as a product manager in startups was confusing. The reality didn’t match the frameworks and job descriptions I had read. I spent time worrying about the wrong things before I figured out what truly mattered. That experience led me to create a YouTube playlist called <em> <a href="https://youtube.com/playlist?list=PLD3My0iO1Nooxy2KWSVg56kFbbzT5EbZ9&si=SqZJd-mX7qA5Y0Av" target="_blank" rel="noopener noreferrer">
  Startup PM Reality</a> </em>, aimed at helping early product managers navigate startup environments with more clarity and less unnecessary pressure.
  </p>

  <p>
    Outside of work, I contribute to the ecosystem through speaking, volunteering, mentoring, and engaging in meaningful conversations while continuing to learn from others. I also run a  <em> <a href="https://www.youtube.com/@aminatfowokebalogun" target="_blank" rel="noopener noreferrer">
  Youtube Channel</a> </em> focused on career growth and innovation, where I host discussions with guests to share practical insights with a broader audience.
  </p>
  </b>
                </Typography>
                <br/>
                <Typography style={{fontSize:'18px', lineHeight:'2'}}>
                { Strengths.map((Item, index)=>{
                    return(
                        <React.Fragment key={index}>
                            <ul>
                                <li>
                                    <b>{Item.title}: </b>
                                    <span>{Item.brief}</span>
                                </li>
                            </ul>
                        </React.Fragment>
                    )
                })}
                </Typography>
                <div>
                <Typography
                    style={{fontFamily:'Oswald', lineHeight:'3', fontSize:'25px', letterSpacing:'3px'}}
                >
                    CERTIFICATIONS
                </Typography>
                <Typography>
                    { Certifications.map((Item, index)=>{
                        return (
                            <React.Fragment key={index}>
                                <b>
                                    <a href={Item.link} target="_blank" rel="noopener noreferrer" style={{color:'black', textDecoration:'none', fontSize:'20px', lineHeight:'2'}}>
                                        {Item.title}
                                    </a>
                                </b>
                                <span>
                                    <Icon
                                        onClick={() => setOpenedDescription(openedDescription === index ? -1 : index)}
                                        style={{float:'right'}}
                                        icon="ooui:expand"
                                    />
                                </span>
                                { openedDescription === index && (
                                    <Typography style={{fontSize:'18px'}}>
                                        {Item.description}
                                        <span>
                                            <b>
                                                <a href={Item.link} target="_blank" rel="noopener noreferrer" style={{color:'black'}}>
                                                    View Certification
                                                </a>
                                            </b>
                                        </span>
                                    </Typography>
                                )}
                                <hr/>
                                <br/>
                            </React.Fragment>
                        );
                    })}
                </Typography>
                </div>

                <div>
                    <Typography
                        style={{fontFamily:'Oswald', lineHeight:'3', fontSize:'25px', letterSpacing:'3px'}}
                    >
                        SKILLS
                    </Typography>
                    <Typography style={{fontSize:'18px', lineHeight:'3'}}>
                        { Skills.map((Item, index)=>{
                            return(
                                <React.Fragment key={index}>
                                    <b>{Item.type}: </b>
                                    <span>{Item.list}</span>
                                    <br/>
                                </React.Fragment>
                            )
                        })}
                    </Typography>
                </div>
                <br/>
                <Typography
                    style={{fontFamily:'Oswald', lineHeight:'3', fontSize:'25px', letterSpacing:'3px'}}>
                    TOOLS
                </Typography><br/>
                <AliceCarousel
                    mouseTracking
                    items={items}
                    responsive={responsive}
                />
                <br/>

                <div>
                    <Typography
                        style={{fontFamily:'Oswald', lineHeight:'3', fontSize:'25px', letterSpacing:'3px'}}
                    >
                        INTERESTS
                    </Typography>
                    <Typography style={{fontSize:'18px'}}>
                        {Intrests.map((Item, index)=>{
                            return(
                                <React.Fragment key={index}>
                                    <ul><li> {Item.name} </li> </ul>
                                </React.Fragment>
                            )
                        })}
                    </Typography>
                </div>
            </Container>
        :
            <MobileContainer>
                <Typography
                    style={{fontFamily:'Oswald', textAlign:'center', lineHeight:'2', fontSize:'25px', letterSpacing:'1px'}}
                >
                    <br/>
                    TECHNICAL PRODUCT MANAGER | (TECH ENTHUSIAST & ADVOCATE)
                </Typography><br/>
                <Typography
                    style={{letterSpacing:'1px', lineHeight:'2'}}
                >
                 <b>
  <p>
    I’m a <strong>Technical Product Manager</strong> passionate about making people’s lives easier through digital technology. What drives me is seeing how innovation can simplify complex processes and create real impact. I care about building things that last and truly matter.
  </p>

  <p>
    In my role, I bridge the gap between technical teams and stakeholders, ensuring that the products we build deliver real, tangible value.
  </p>

  <p>
    With over four years of experience in the geospatial and GovTech sector, I have worked on and launched products that have supported institutional change and driven social and economic impact.
  </p>

  <p>
    The advancement of AI has sparked my fascination with computer vision. I am exploring its applications because I believe true intelligence involves systems that can see and act on what they observe in real time.
  </p>

<p>
    Beyond my product work, I am diving into scientific AI research, focusing on understanding the mechanics behind technology and experimenting with efficiently training AI models.
</p>
  <p>
    My early experience as a product manager in startups was confusing. The reality didn’t match the frameworks and job descriptions I had read. I spent time worrying about the wrong things before I figured out what truly mattered. That experience led me to create a YouTube playlist called <em> <a href="https://youtube.com/playlist?list=PLD3My0iO1Nooxy2KWSVg56kFbbzT5EbZ9&si=SqZJd-mX7qA5Y0Av" target="_blank" rel="noopener noreferrer">
  Startup PM Reality</a> </em>, aimed at helping early product managers navigate startup environments with more clarity and less unnecessary pressure.
  </p>

  <p>
    Outside of work, I contribute to the ecosystem through speaking, volunteering, mentoring, and engaging in meaningful conversations while continuing to learn from others. I also run a  <em> <a href="https://www.youtube.com/@aminatfowokebalogun" target="_blank" rel="noopener noreferrer">
  Youtube Channel</a> </em> focused on career growth and innovation, where I host discussions with guests to share practical insights with a broader audience.
  </p>
  </b>
                </Typography>
                <br/>
                <Typography style={{fontSize:'18px', lineHeight:'2'}}>
                { Strengths.map((Item, index)=>{
                    return(
                        <React.Fragment key={index}>
                            <ul>
                                <li>
                                    <b>{Item.title}: </b>
                                    <span>{Item.brief}</span>
                                </li>
                            </ul>
                        </React.Fragment>
                    )
                })}
                </Typography>
                <div>
                <Typography
                    style={{fontFamily:'Oswald', lineHeight:'3', fontSize:'25px', letterSpacing:'3px'}}
                >
                    CERTIFICATIONS
                </Typography>
                <Typography>
                    { Certifications.map((Item, index)=>{
                        return(
                            <React.Fragment key={index}>
                                <b>
                                                <a href={Item.link} target="_blank" rel="noopener noreferrer"
                                       style={{color:'black', textDecoration:'none', fontSize:'20px', lineHeight:'2'}}
                                    >
                                        {Item.title}
                                    </a>
                                </b>
                                <span>
                                    <Icon
                                        onClick={() => setOpenedDescription(openedDescription === index ? -1 : index)}
                                        style={{float:'right'}}
                                        icon="ooui:expand"
                                    />
                                </span>
                                { openedDescription === index && (
                                    <Typography style={{fontSize:'18px'}}>
                                        {Item.description}
                                        <span>
                                            <b>
                                                <a href={Item.link} target="_blank" rel="noopener noreferrer" style={{color:'black'}}>
                                                    View Certification
                                                </a>
                                            </b>
                                        </span>
                                    </Typography>
                                )}
                                <hr/>
                                <br/>
                            </React.Fragment>
                        )
                    })}
                </Typography>
                </div>

                <div>
                    <Typography
                        style={{fontFamily:'Oswald', lineHeight:'3', fontSize:'25px', letterSpacing:'3px'}}
                    >
                        SKILLS
                    </Typography>
                    <Typography style={{fontSize:'18px', lineHeight:'3'}}>
                        { Skills.map((Item, index)=>{
                            return(
                                <React.Fragment key={index}>
                                    <b>{Item.type}: </b>
                                    <span>{Item.list}</span>
                                    <br/>
                                </React.Fragment>
                            )
                        })}
                    </Typography>
                </div>
                <br/>
                <Typography style={{fontFamily:'Oswald', lineHeight:'3', fontSize:'25px', letterSpacing:'3px'}}>
                    TOOLS
                </Typography><br/>
                <AliceCarousel
                    mouseTracking
                    items={items}
                    responsive={responsive}
                />
                <br/>
                <div>
                    <Typography
                        style={{fontFamily:'Oswald', lineHeight:'3', fontSize:'25px', letterSpacing:'3px'}}
                    >
                        INTERESTS
                    </Typography>
                    <Typography style={{fontSize:'18px'}}>
                        {Intrests.map((Item, index)=>{
                            return(
                                <React.Fragment key={index}>
                                    <ul><li> {Item.name} </li> </ul>
                                </React.Fragment>
                            )
                        })}
                    </Typography>
                </div>
            </MobileContainer>
        }
        </div>
        </>
    )
}

export default AboutMe;